import React from 'react';
import { Box, Typography } from '@mui/material';
import ManagerNavBar from '../../Components/NavigationBar/ManagerNavBar';
import Orders from '../../Components/Manager/Orders/Orders';

function ManagerOrders() {
  return (
    <ManagerNavBar>
      <Box sx={{ px: 6, py: 2 }}>
        <Orders />
      </Box>
    </ManagerNavBar>
  );
}

export default ManagerOrders;